"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceService = void 0;
// @ts-ignore
var Navigate_1 = require("./../navigate/Navigate");
var ServiceService = /** @class */ (function () {
    function ServiceService(retry) {
        if (retry === void 0) { retry = 0; }
        this.sessionService = {
            sessionId: function () { return null; },
            logout: function () { }
        };
        this.retry = 0;
        this.retry = retry;
    }
    ServiceService.prototype.request = function (listener, xinterface, xmethodid, xparamarray) {
        this.requestInt(listener, xinterface, xmethodid, xparamarray, this.retry);
    };
    ServiceService.prototype.requestInt = function (listener, xinterface, xmethodid, xparamarray, retry) {
        var _this = this;
        var url = "".concat(window.location.protocol, "//").concat(window.location.host, "/el/json");
        var requestUrl = "".concat(url, "/").concat(xinterface).concat(xmethodid);
        var params = JSON.stringify(xparamarray);
        var sessionId = this.sessionService.sessionId();
        var headers = sessionId ? { AuthSessionId: sessionId } : {};
        var rawResponse = {};
        // @ts-ignore
        var referer = Navigate_1.Navigate.url() || "";
        fetch(requestUrl, {
            method: "POST",
            headers: __assign(__assign({}, headers), { "Content-Type": "application/json", "X-Referer": referer }),
            body: params,
        })
            .then(function (response) {
            rawResponse.value = response;
            return response.json();
        })
            .then(function (responseObj) {
            if (responseObj == null) {
                responseObj = { success: true };
            }
            responseObj.rawResponse = rawResponse.value;
            if (responseObj.success || retry <= 0) {
                listener(responseObj);
            }
            else {
                retry = retry - 1;
                setTimeout(function () {
                    _this.requestInt(listener, xinterface, xmethodid, xparamarray, retry);
                }, 100);
            }
        }, function (error) {
            if (error.status === 401) {
                _this.sessionService.logout();
            }
            var errorObj = {
                success: false,
                errorType: "FAILED_POST",
                error: "Post operation failed",
                rawResponse: error,
            };
            if (retry <= 0) {
                listener(errorObj);
            }
            else {
                retry = retry - 1;
                setTimeout(function () {
                    _this.requestInt(listener, xinterface, xmethodid, xparamarray, retry);
                }, 100);
            }
        });
    };
    return ServiceService;
}());
exports.ServiceService = ServiceService;
